var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cert-status"},[_c('div',{class:_vm.statusClass},[(_vm.status === 'awarded')?_c('CheckCircle',{staticClass:"cert-status__awarded-icon"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.status))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }